export const RECENTLY_VIEWED = 'recentlyViewed';
export const RECENTLY_VIEWED_THRESHOLD = 20;